// Wrapper for the next apps own API
import axios from 'axios';
import { generateRandomClientId } from 'common-state/src/helpers/utils';

export type WebAuthConfig = {
  urlPrefix: string;
  extraHeaders?: Record<string, string>;
  host: string;
};

export const initWebAuthApi = (config: WebAuthConfig) => {
  async function asyncRequest(requestType: string, url: string, data = {}) {
    const requestConfig: any = {
      method: requestType,
      url: `${config.urlPrefix}/webauth/${url}`,
      headers: {
        siteorigin: config.host,
        'x-dw-brand-domain': config.host,
        'x-dw-client-id': sessionStorage.getItem('sessionUID') || generateRandomClientId(),
        ...config.extraHeaders,
      },
    };
    if (data) {
      requestConfig.data = data;
    }

    const response = await axios.request(requestConfig);
    return response.data;
  }

  return {
    Auth: {
      //creates a new anonymous access token (cookie) which will require a new cart etc
      getAnonymousToken: async () =>
        asyncRequest('POST', `anonymous/token`, {
          tokenType: 'cart',
        }),

      //returns existing token. if csrf value is missing that means session has expired. In that case;
      //  anon user will need to call getAnonymousToken()
      //  logged user will need to call refresh()
      reload: async () =>
        asyncRequest('POST', `pagereload`, {
          type: 'cart',
        }),

      //refreshes the access token (cookie) for logged in user (unlike anon user this allows cart to be retained)
      refresh: async () => asyncRequest('POST', `refresh`),
    },
  };
};
